import React from "react";
import { Link } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import CancelButton from "presentation/components/buttons/cancel";


class EvaluationTypeTermForm extends React.Component {
    constructor(props) {
        super(props);

    }
    render() {
        let { loading, form, handleChange, handleSubmit, component } = this.props;
        return (
            <Form>
                <h4>Termos do tipo de avaliação</h4>
                <div className="form">
                    <Form.Label htmlFor="name">Nome</Form.Label>
                    <Form.Control
                        type="text"
                        id="name"
                        name="name"
                        defaultValue={form.name}
                        onChange={(e) => handleChange(e, component)}
                        aria-describedby="nameHelpBlock"
                    />
                    <Form.Text id="nameHelpBlock" muted>
                        Informe o tipo de origem de questão
                    </Form.Text>
                </div>
                <div className="form mt-2">
                    <Form.Label htmlFor="numericValue">Valor numérico</Form.Label>
                    <Form.Control
                        type="text"
                        id="numericValue"
                        name="numericValue"
                        defaultValue={form.numericValue}
                        onChange={(e) => handleChange(e, component)}
                        aria-describedby="numericValueHelpBlock"
                    />
                    <Form.Text id="numericValueHelpBlock" muted>
                        Escolha o valor numérico
                    </Form.Text>
                </div>
                <div className="mt-3">
                    <CancelButton
                        containerProps={{
                            as: Link,
                            to: `/termos-tipo-avaliacao/tipo-avaliacao/${form.evaluationTypeId}`
                        }}
                    />
                    <Button disabled={loading} variant="success" className="float-end" onClick={() => handleSubmit()}>Salvar</Button>
                </div>
            </Form>
        );
    };
}

export default EvaluationTypeTermForm;